import api from "./api";
import { JWTToken } from "../routes/privateRoute";
import jwt_decode from "jwt-decode";

export default class TransferApiDireto {
  static postTransferSolicitation = async (obj: any) => {
    const token = window.localStorage.getItem("token");
    let manualParam = "";

    if (token) {
      try {
        const decoded: JWTToken = jwt_decode(token);
        if (decoded.loginPermissoes) {
          const loginPermissoes: number[] = JSON.parse(decoded.loginPermissoes);
          if (loginPermissoes.includes(41)) {
            manualParam = "?manual=true";
          }
        }
      } catch (error) {}
    }

    const response = await api.post(`/Transferenciasnovo${manualParam}`, obj);
    return response.data;
  };

  static getTransferSolicitation = async (
    idStatus: number,
    idCliente: number,
    dataInicio: string,
    dataFim: string,
    Page: number,
    RecordsPerPage: number,
    Search: string,
    valorInicio: number,
    valorFim: number
  ) => {
    const response = await api.get(
      `/Transferenciasnovo?idStatus=${idStatus}&idCliente=${idCliente}&dataInicio=${dataInicio}&dataFim=${dataFim}&Page=${Page}&RecordsPerPage=${RecordsPerPage}&Search=${Search}&valorInicio=${valorInicio}&ValorFim=${valorFim}`
    );
    return response;
  };

  static getTransferPerId = async (idTransfer: any) => {
    const response = await api.get(`/Transferenciasnovo/${idTransfer}`);
    return response.data;
  };

  static deleteTransferPerId = async (id: number, obj: any) => {
    const response = await api.post(`/Transferenciasnovo/${id}/cancelar`, obj);
    return response.data;
  };

  static cancelamentoRemessaTransferencia = async (id: number) => {
    const response = await api.delete(
      `/Transferenciasnovo/${id}/remover-remessa`
    );
    return response.data;
  };

  static confirmTransfer = async (
    id: number,
    code: string,
    valor: number,
    tipoChave: string
  ) => {
    let form: any = new FormData();
    form.append("codigo", code);
    form.append("valor", valor);
    form.append("tipoChave", tipoChave);
    const response = await api.post(
      `/Transferenciasnovo/${id}/Confirmar`,
      form
    );
    return response.data;
  };

  static exportTransferList = async (
    idStatus: any,
    idCliente: number,
    dataInicio: any,
    dataFim: any
  ) => {
    const response = await api.get(
      `/Transferenciasnovo/exportacao/download?idStatus=${idStatus}&dataInicio=${dataInicio}&dataFim=${dataFim}&idCliente=${idCliente}`,
      {
        responseType: "blob",
      }
    );
    return response.data;
  };

  static getTransferenciasAutomaticas = async (
    Page: number,
    RecordsPerPage: number
  ) => {
    const response = await api.get(
      `/Transferenciasnovo/relatorios/quantidades?Page=${Page}&RecordsPerPage=${RecordsPerPage}`
    );
    return response;
  };

  static getVerificacaoCisa = async (tipo: string, id: number) => {
    const response = await api.get(`/RemessaBancaria?tipo=${tipo}&id=${id}`);
    return response.data;
  };
}
